import React, { useCallback, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

export interface InspectionRefreshContext { onInspectionCreated: () => void; }

export default function Layout(): React.ReactElement {
    const [shouldRefreshInspection, setShouldRefreshInspection] = useState(false);

    const handleInspectionCreated = useCallback(() => {
        setShouldRefreshInspection(true);
    }, []);

    return (
        <div className="flex flex-col h-screen p-3 xl:p-5 overflow-hidden">
            <Header
                shouldRefreshInspection={shouldRefreshInspection}
                onInspectionRefreshed={() => setShouldRefreshInspection(false)}
            />
            <main className="flex-1 overflow-hidden h-full">
                <Outlet context={{ onInspectionCreated: handleInspectionCreated }} />
            </main>
            <Footer />
        </div>
    );
};